export enum ApiRoutes {

    // Products
    GetProducts = 'api/shop/?{pageNumber:QueryString}&{collections:QueryString}&{filters:QueryString}',
    GetTopSelling = 'api/shop/topselling',
    GetProductsById = 'api/shop/?{productIds:QueryString}',
    GetProductsByCollection = 'api/shop/get-by-collection/{pageNumber}/collection',
    GetProductBySlug = 'api/shop/slug/{slug}',
    SearchProducts = 'api/shop/{params:QueryString}',


    //Collection
    GetCollections = 'api/shop/collections',
    GetCollection = 'api/shop/collections/{id}',
    GetShopProductBySlug = 'api/shop/slug/{slug}',

    //Wishlist
    GetWishlist = 'api/wishlist',
    fetchProductInWishlist = 'api/wishlist/product/{productId}',
    AddToWishlist = 'api/wishlist/product/{productId}',
    BulkAddToWishlist = 'api/wishlist/bulk-add',
    RemoveFromWishlist = 'api/wishlist/product/{productId}',

    //Cart
    AddToCart = 'api/cart',
    MergeCart = 'api/cart/mergeCartOnLogin',
    GetCartItems = 'api/cart',
    RemoveFromCart = 'api/cart/item/{itemId}',
    UpdateCartQuantity = 'api/cart/updateCartQuantity/{cartItemId}/{quantity}',
    GetStockAvailability = 'api/cart/getStockAvailability',

    //Order
    CreateOrder = 'api/orders/create',
    GetOrders = 'api/orders',
    GetOrder = 'api/orders/{orderId}',
    VerifyPayment = 'api/orders/verify-payment',
    ValidateCoupon = 'api/orders/validate-coupon/{customerId}/{couponCode}',

    //User
    TriggerOTPForValidation = 'api/auth/trigger-otp',
    ValidateOtpAndFetchUser = 'api/auth/customer',
    GetUser = 'api/users/userdetail/{tenantId}/{id}',
    UpdateUser = 'api/users',
    AddAddress = 'api/users/add-address',
    UpdateAddress = 'api/users/update-address',
    UpdateDefaultAddress = 'api/users/update-defaultaddress/{addressId}/{tenantId}/{loginId}',
    DeleteAddress = 'api/users/delete-address/{addressId}/{tenantId}/{loginId}',
}